module.exports = __webpack_public_path__ + "static/3-1-c05cdf6293bcadb22924f713a4d8beea.gif";